export default function ids(entities) {
    if (Array.isArray(entities)) {
        return entities.map((entity) => ids(entity));
    }

    return `${entities}Ids`;
}
